export function disabledButtons() {
  const tooltipTexts = {
    ru: 'В разработке',
    en: 'In development',
    pt: 'Em desenvolvimento',
  };

  const lang = document.documentElement.lang || 'ru';
  const tooltipText = tooltipTexts[lang] || tooltipTexts.en;

  const links = document.querySelectorAll('.hero__social-link');

  links.forEach((link) => {
    const href = link.getAttribute('href');
    if (href && href !== '#') return;
    link.classList.add('hero__social-link--disabled');
    link.setAttribute('data-tooltip', tooltipText);
    link.addEventListener('click', (e) => e.preventDefault());
  });
}
